import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function CTAButton({
  text = 'SÍ, QUIERO DORMIR ESTA NOCHE',
  showGuarantee = true,
  href = '#oferta'
}: {
  text?: string;
  showGuarantee?: boolean;
  href?: string;
}) {
  const isExternal = href.startsWith('http');
  return <div className="flex flex-col items-center w-full mt-8" data-id="element-14">
      <motion.a href={href} {...isExternal ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} onClick={!isExternal ? (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      document.getElementById(href.replace('#', ''))?.scrollIntoView({
        behavior: 'smooth'
      });
    } : () => {
      trackAddToCart();
    }} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="block w-full max-w-md bg-amber hover:bg-amberHover text-white font-bold py-4 px-6 rounded-full shadow-lg transition-colors text-lg sm:text-xl tracking-wide text-center cursor-pointer" data-id="element-15">
        {text}
      </motion.a>
      {showGuarantee && <p className="text-xs sm:text-sm text-taupe/70 mt-3 text-center flex items-center justify-center gap-1.5" data-id="element-16">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-17">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-18"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-19"></path>
          </svg>
          Compra segura. Acceso instantáneo en formato PDF.
        </p>}
    </div>;
}